/**
 * Figma: https://www.figma.com/design/XwMQV9iBJ1Ec4sOzWMEZcK/-Dev--Customer-Hub-2.3-%E2%80%93-Phase-1?node-id=2718-101820&m=dev
 */

import { useLabel } from '../../../i18n'

interface OrderHeaderProps {
  orderNumber: string
  subtitle?: string
}

export default function OrderHeader({
  orderNumber,
  subtitle,
}: OrderHeaderProps) {
  const t = useLabel()

  return (
    <div className="flex flex-col gap-4">
      <h1 className="text-xl leading-xl lg:text-2xl lg:leading-2xl font-medium tracking-heading text-text">
        {t('orderList.header.orderNumber', { orderNumber })}
      </h1>
      {subtitle && (
        <span className="text-sm leading-sm lg:text-base lg:leading-base font-light text-text">
          {subtitle}
        </span>
      )}
    </div>
  )
}
